<template>
  <div v-if="data">
    <van-overlay :show="show" z-index="2000" @click="bindClose">
      <div class="common-taost" @click.stop>
        <div class="tonic-image-content">
          <img class="tonic-image" :src="data.p_image" alt="" />
          <img class="tonic-brand" :src="data.brand_img" alt="" />
        </div>
        <div class="title">{{ data.p_title }}</div>
        <div class="tag-list">
          <div
            class="tag-item"
            v-for="(item, index) in data.efficacy"
            :key="index"
            >{{ item }}</div
          >
        </div>
        <div class="desc"
          >{{ data.every_times_num }}{{ data.min_unit_txt }}·{{
            data.take_suggested_time_txt
          }}</div
        >
        <div class="btn-list">
          <div
            class="btn-item btn-confirm"
            @click="bindConfirm"
            v-clickBuried
            :data-click-buried="['CLICK_EAT_' + id, 'CLICK_EAT']"
            >我吃过了
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  data() {
    return {
      show: true
    }
  },
  watch: {
    value() {
      this.show = this.value
    }
  },
  created() {
    this.show = this.value
  },
  methods: {
    bindClose() {
      this.$emit('input')
    },
    bindConfirm() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.common-taost {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
  width: 248px;
  box-sizing: border-box;
  padding: 28px 20px 20px;
  background: linear-gradient(180deg, #ddfcff 0%, #effeff 35%, #ffffff 100%);
  border-radius: 12px;

  .tonic-image-content {
    width: 90px;
    height: 90px;
    margin: 0 auto;
    position: relative;
    margin-top: -45px;
    margin-bottom: 17px;
    border-radius: 6px;
    overflow: hidden;

    .tonic-image {
      width: 90px;
      height: 90px;
      box-sizing: border-box;
      border: 2px solid #ffffff;
    }

    .tonic-brand {
      position: absolute;
      left: 0;
      top: 0;
      width: 45px;
      height: 15px;
      border-radius: 4px 0px 4px 0px;
      object-fit: contain;
    }
  }

  .tag-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .tag-item {
      white-space: nowrap;
      padding: 0px 3px;
      font-size: 9px;
      background: rgba(254, 248, 225, 1);
      font-size: 10px;
      font-family: PingFangSC, PingFang SC;
      color: #fe8b1a;
      line-height: 14px;
      border-radius: 2px;
      margin-right: 8px;
      margin-bottom: 4px;
    }
  }

  .title {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    line-height: 20px;
    margin-bottom: 9px;
  }

  .desc {
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    line-height: 17px;
    margin-top: 2px;
    margin-bottom: 26px;
  }

  .btn-list {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;

    .btn-item {
      height: 40px;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.08);
      border-radius: 20px;
    }

    .btn-confirm {
      background: #03d4e6;
      color: #ffffff;
    }
  }
}
</style>
